export const COVERAGE_TABS = ['EC2', 'RDS'] as const;

export type CoverageTabs = typeof COVERAGE_TABS[number];

export const COVERAGE_SERVICE_REPORT_MAP: Record<CoverageTabs, string> = {
  EC2: 'AmazonEC2',
  RDS: 'AmazonRDS',
};

export const SUMMARY_TABS = ['EC2', 'RDS', 'Redshift', 'ElastiCache', 'OpenSearch'] as const;

export type SummaryTabs = typeof SUMMARY_TABS[number];

export const SUMMARY_SERVICE_REPORT_MAP: Record<SummaryTabs, string> = {
  EC2: 'AmazonEC2',
  RDS: 'AmazonRDS',
  Redshift: 'AmazonRedshift',
  ElastiCache: 'AmazonElastiCache',
  OpenSearch: 'AmazonOpenSearch'
};
